import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable, catchError, map, throwError } from "rxjs";

export interface ChitPlan {
  id: number;
  name: string;
  isGoldPlan: boolean;
  duration: number;
  minAmount: string;
  maxAmount: string;
  benefit: string;
  startDate: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface ChitPlansResponse {
  success: boolean;
  message: string;
  data: ChitPlan[];
}





@Injectable({
  providedIn: "root",
})
export class ChitService {
  private baseURL = environment.apiUrl; // replace with your backend URL

  constructor(private httpClient: HttpClient) {}

  getAllChits(): Observable<ChitPlansResponse> {
    return this.httpClient.get<ChitPlansResponse>(`${this.baseURL}/chitplans`).pipe(
      catchError((error) => {
        return throwError(() => new Error("Failed to fetch chit plans"));
      })
    );
  }

  payChit(payload: any): Observable<any> {
  return this.httpClient.post<any>(`${this.baseURL}/admin/accounts/payments`, payload);
}



getPrintDetails(accountId: string, planId: number): Observable<any> {
  return this.httpClient
    .get<any>(`${this.baseURL}/printer/passbook/${accountId}/${planId}`)
    .pipe(
      map((data) => {
        // Sort data by receiptDate ascending (oldest first, recent last)
        return data.sort(
          (a: any, b: any) => new Date(a.receiptDate).getTime() - new Date(b.receiptDate).getTime()
        );
      }),
      catchError((error) => {
        return throwError(() => new Error("Failed to fetch print details: " + error));
      })
    );
}

}
